import { useRef, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Divider,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import SignatureCanvas from "react-signature-canvas";
import { motion } from "motion/react";


const CanvaFirmaContrato = ({ folio, onRegresar, onConfirmar, }) => {

    const signatureRef = useRef(null);

    const [firmaVacia, setFirmaVacia] = useState(false);


    // =========================
    // LIMPIAR FIRMA
    // =========================

    const limpiarFirma = () => {

        signatureRef.current?.clear();

        setFirmaVacia(false);
    };


    // =========================
    // CONFIRMAR FIRMA
    // =========================

    const confirmarFirma = () => {

        //sale error, se ocupa mandar tambien a la api la foto para guardarla, mensaje de correcto y ya regresar a la pagina principal

        if (!signatureRef.current) {
            return;
        }

        if (signatureRef.current.isEmpty()) {

            setFirmaVacia(true);

            return;
        }

        const firma = signatureRef.current
            .getCanvas()
            .toDataURL("image/png");


        // Mandamos la firma al componente padre
        onConfirmar(firma);
    };


    return (
        <motion.div
            initial={{
                opacity: 0,
                x: 40,
            }}
            animate={{
                opacity: 1,
                x: 0,
            }}
            transition={{
                duration: 0.5,
                ease: [0.22, 1, 0.36, 1],
            }}
        >

            <Box
                sx={{
                    width: "100%",
                }}
            >

                {/* =========================
                    REGRESAR
                ========================= */}

                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={onRegresar}
                    sx={{
                        color: "#66756a",
                        textTransform: "none",

                        mb: 2,

                        "&:hover": {
                            backgroundColor: "#f3f6f3",
                        },
                    }}
                >
                    Regresar
                </Button>


                {/* =========================
                    HEADER
                ========================= */}

                <Box
                    sx={{
                        textAlign: "center",
                        mb: 3,
                    }}
                >

                    <Box
                        sx={{
                            width: 58,
                            height: 58,

                            mx: "auto",
                            mb: 2,

                            borderRadius: "16px",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            background: `
                                linear-gradient(
                                    135deg,
                                    #29452f,
                                    #3f6847
                                )
                            `,

                            color: "#fff",

                            boxShadow: `
                                0 8px 20px
                                rgba(41,69,47,.25)
                            `,
                        }}
                    >
                        <CheckCircleOutlineIcon
                            sx={{
                                fontSize: 30,
                            }}
                        />
                    </Box>


                    <Typography
                        sx={{
                            fontSize: {
                                xs: "25px",
                                md: "29px",
                            },

                            fontWeight: 700,

                            color: "#243b29",

                            mb: 0.5,
                        }}
                    >
                        Firma del contrato
                    </Typography>


                    <Typography
                        sx={{
                            fontSize: "14px",
                            color: "#718076",
                        }}
                    >
                        Contrato #{folio}
                    </Typography>

                </Box>


                <Divider sx={{ mb: 3 }} />


                {/* =========================
                    INSTRUCCIONES
                ========================= */}

                <Typography
                    sx={{
                        color: "#526158",
                        fontSize: "14px",
                        textAlign: "center",
                        mb: 2,
                    }}
                >
                    Dibuja tu firma dentro del recuadro
                    usando tu dedo o el mouse.
                </Typography>


                {/* =========================
                    CANVAS
                ========================= */}

                <Box
                    sx={{
                        position: "relative",

                        width: "100%",

                        height: {
                            xs: 220,
                            sm: 260,
                            md: 280,
                        },

                        border: firmaVacia
                            ? "2px dashed #d32f2f"
                            : "2px dashed #b8c7bb",

                        borderRadius: "16px",

                        backgroundColor: "#fafcfa",

                        overflow: "hidden",

                        transition: "border .2s",
                    }}
                >

                    <SignatureCanvas
                        ref={signatureRef}

                        penColor="#0000FF"

                        minWidth={1}
                        maxWidth={2.5}

                        canvasProps={{
                            style: {
                                width: "100%",
                                height: "100%",

                                display: "block",

                                touchAction: "none",

                                cursor: "crosshair",
                            },
                        }}
                    />


                    {/* TEXTO DE AYUDA */}

                    <Typography
                        sx={{
                            position: "absolute",

                            bottom: 10,
                            left: 0,
                            right: 0,

                            textAlign: "center",

                            fontSize: "12px",

                            color: "#a0aaa2",

                            pointerEvents: "none",
                        }}
                    >
                        Firma aquí
                    </Typography>

                </Box>


                {/* =========================
                    ERROR
                ========================= */}

                {firmaVacia && (
                    <Typography
                        sx={{
                            color: "#d32f2f",

                            fontSize: "13px",

                            textAlign: "center",

                            mt: 1.5,
                        }}
                    >
                        Debes ingresar tu firma para continuar.
                    </Typography>
                )}


                {/* =========================
                    BOTONES
                ========================= */}

                <Box
                    sx={{
                        display: "flex",

                        gap: 2,

                        mt: 3,
                    }}
                >

                    {/* LIMPIAR */}

                    <Button
                        fullWidth

                        variant="outlined"

                        startIcon={
                            <DeleteOutlineIcon />
                        }

                        onClick={limpiarFirma}

                        sx={{
                            height: "52px",

                            borderRadius: "12px",

                            textTransform: "none",

                            fontWeight: 600,

                            color: "#29452f",

                            borderColor: "#b8c7bb",

                            "&:hover": {
                                borderColor: "#29452f",
                                backgroundColor: "#f3f7f3",
                            },
                        }}
                    >
                        Limpiar
                    </Button>


                    {/* CONFIRMAR */}

                    <Button
                        fullWidth

                        variant="contained"

                        startIcon={
                            <CheckCircleOutlineIcon />
                        }

                        onClick={confirmarFirma}

                        sx={{
                            height: "52px",

                            borderRadius: "12px",

                            textTransform: "none",

                            fontWeight: 700,

                            background: `
                                linear-gradient(
                                    135deg,
                                    #29452f,
                                    #3f6847
                                )
                            `,

                            boxShadow: `
                                0 8px 18px
                                rgba(41,69,47,.25)
                            `,

                            "&:hover": {
                                background: `
                                    linear-gradient(
                                        135deg,
                                        #203924,
                                        #34583d
                                    )
                                `,

                                transform: "translateY(-2px)",
                            },
                        }}
                    >
                        Confirmar firma
                    </Button>

                </Box>

            </Box>

        </motion.div>
    );
};

export default CanvaFirmaContrato;